import Vue from 'vue';
import VeeValidate from 'vee-validate';

import App from './App.vue';

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
    delay: 500,
});

new Vue({
    render: h => h(App),
}).$mount('#app');
